import { baseUrl } from "services/config/url";

export const forceUpdate = async (logout: boolean) => {
    // remove service worker
    if (navigator.serviceWorker) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (let registration of registrations) {
                registration.unregister();
            }
        });
    }
    // remove local storage
    if (logout) {
        const token = localStorage.getItem("token");
        await fetch(`${baseUrl}/auth/logout`, {
            method: "POST",
            headers: { Authorization: `${token}` },
        }).catch((err) => console.log(err));
        localStorage.clear();
    }
    // reload page
    window.location.reload();
}
